import { CellText } from "assets/js/Styles";
import React from "react";
import { formatTime, getFormattedDateString } from "utility/helpers";

const attendanceColumns = () => {
  return [
    {
      name: "Date",
      selector: (attendanceDate) => attendanceDate,
      identifier: "attendanceDate",
      grow: 1,
      sortable: false,
      cell: ({ attendanceDate }) => (
        <CellText>
          {getFormattedDateString(attendanceDate, "MMM dd, yyyy")}
        </CellText>
      ),
    },
    {
      name: "Time",
      selector: ({ createdAtTime }) => createdAtTime,
      identifier: "createdAtTime",
      grow: 1,
      sortable: false,
      cell: ({ createdAtTime }) => (
        <CellText>{formatTime(createdAtTime) ?? ""}</CellText>
      ),
    },
    {
      name: "Attended",
      selector: ({ attended }) => attended,
      identifier: "attended",
      grow: 1,
      sortable: false,
      cell: ({ attended }) => <CellText>{attended}</CellText>,
    },
  ];
};

export default attendanceColumns;
